<div class="card">
    <app-scorecard-row *ngFor="let row of rows(); trackBy: trackByRowName"
                       class="row"
                       [class]="row.classes"
                       [row]="row"
    />
</div>
